import log from "loglevel";

log.setLevel("info"); // Level: trace, debug, info, warn, error

const logger = {
    debug: (...args) => log.debug(...args),
    info: (...args) => log.info(...args),
    warn: (...args) => log.warn(...args),
    error: (...args) => log.error(...args),
};

export default logger;
